// import { title } from 'process';
import { useLayoutEffect, useState } from 'react';
import ContactUsNewImg from '../../../../assets/images/deals/contactUsNew.png';
import LinkButton from '../../../common/LinkButton';

const contactCards: { subtitle: string; title: string; btn: string }[] = [
    {
        subtitle: 'Have a question on our products?',
        title: 'Schedule meeting with our sales team',
        btn: 'Book a meeting',
        // img: Alma,
    },
    {
        subtitle: 'Ask us anything',
        title: 'Write directly to us',
        btn: 'Email us',
        // img: emailIcon,
    },
];
type Props = {
    isMobile?: boolean;
    isShowTitle?: boolean;
};

const ContactUsNew: React.FC<Props> = ({ isMobile, isShowTitle = true }) => {
    const [bannerHeight, setBannerHeight] = useState<number>(0);
    useLayoutEffect(() => {
        const contactUsBanner = document.getElementById('contact_us_banner');
        if (contactUsBanner) {
            setBannerHeight(contactUsBanner.offsetHeight || 0);
        }
    }, []);
    return (
        <div
            className={
                isMobile
                    ? 'bg-[#0f2240] flex  flex-col-reverse justify-end h-full'
                    : 'md:grid grid-cols-2 bg-[#0f2240] flex  flex-col-reverse h-full justify-end'
            }
        >
            <div className={isMobile ? 'pb-4 px-6' : 'md:p-8 p-2 mb-5'}>
                <p
                    className={`text-[white] font-[WorkSans-Semibold]  font-semibold text-[22px] uppercase ${
                        isMobile ? 'md:text-[22px] mb-8 mt-4' : 'md:text-[30px] lg:text-[32px] mb-10 mt-5'
                    }`}
                >
                    Learn more about <br /> our products
                </p>
                <div id="contact_us_banner">
                    {contactCards?.map((item, index) => {
                        return (
                            <div key={index}>
                                {' '}
                                <div className={`flex flex-col`}>
                                    <p
                                        className={`${
                                            isMobile ? 'text-[10px] mb-2' : 'text-xs'
                                        } font-[WorkSans] text-[#41D17E] uppercase mb-4`}
                                    >
                                        {item.subtitle}
                                    </p>
                                    {isShowTitle && (
                                        <p
                                            className={`${
                                                isMobile ? 'text-xl mb-2' : 'text-2xl mb-4'
                                            } font-[WorkSans-Semibold]  text-white  font-semibold`}
                                        >
                                            {item.title}
                                        </p>
                                    )}
                                    {/* <a
                                        className="flex text-white transition ease-in-out delay-150  hover:translate-x-7 hover:scale-110  duration-300 items-center"
                                        href={
                                            index === 0
                                                ? 'https://meetings.hubspot.com/investor2'
                                                : 'mailto:pcs@heli-cap.com'
                                        }
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <span className="font-[WorkSans-Semibold] font-bold text-white uppercase">
                                            {item.btn}
                                        </span>
                                        <LuArrowUpRight className="ml-1" size={'1.5rem'} color="#41D17E" />
                                    </a> */}
                                    <LinkButton
                                        isArrow={true}
                                        title={item.btn}
                                        variant="light"
                                        onClick={() => {
                                            index === 0
                                                ? window.open('https://meetings.hubspot.com/investor2', '_blank')
                                                : (window.location.href = 'mailto:pcs@heli-cap.com');
                                        }}
                                    />
                                </div>
                                {index !== contactCards.length - 1 ? (
                                    <div className={' my-4 border-b border-[white] w-[80%]'}></div>
                                ) : null}
                            </div>
                        );
                    })}
                </div>
            </div>
            <div
                className={isMobile ? 'bg-cover bg-no-repeat' : 'md:ml-4 bg-cover bg-no-repeat'}
                style={{
                    backgroundPosition: 'center',
                    minHeight: `${bannerHeight}px`,
                    backgroundImage: `url(${ContactUsNewImg})`,
                }}
            ></div>
        </div>
    );
};

export default ContactUsNew;
